import React, { useState } from 'react'

import styled from 'styled-components'

import { Button } from '@nexiahome/ui-common/components/primitives/buttons'
import ComboBox from 'components/ComboBox'
import Modal from 'components/Modal'

import { ButtonContainer } from 'styles/shared'

const OPTIONS = ['', 'Customer Moved', 'Warranty', 'Opted Out', 'Not Enrolled in Nexia Home', 'Alerts Not Clearing']

type ActionType = 'create' | 'update'

type ArchiveDeviceModalProps = {
  closeCallback: () => void
  isVisible?: boolean
  actionType: ActionType
  reason?: string
  auid: string
  onUpdateCallback: (updatedReason: string) => Promise<void>
}

const ArchiveDeviceModal = ({ closeCallback, isVisible = false, auid, reason = '', onUpdateCallback, actionType }: ArchiveDeviceModalProps) => {
  const [currentReason, setCurrentReason] = useState(reason)
  const [formUpdated, setFormUpdated] = useState(false)

  const onCancelButtonClicked = () => {
    if (formUpdated) {
      if (confirm('You have unsaved changes, are you sure you want to cancel?')) {
        closeCallback()
      }
    } else {
      closeCallback()
    }
  }

  const onInputChange = (reason) => {
    setFormUpdated(true)
    setCurrentReason(reason)
  }

  const onCreateOrUpdateButtonClicked = async () => {
    await onUpdateCallback(currentReason)

    closeCallback()
  }

  const displayActionType = actionType === 'create' ? 'Archive' : 'Update'

  return (
    <Modal
      variant="sm"
      fullWidth
      title={`${displayActionType} Device`}
      isDisplayed={isVisible}
      closeCallback={() => closeCallback()}
    >
      <S.DeviceId>Device ID: <b>{auid}</b></S.DeviceId>

      <ComboBox
        label="Reason"
        value={currentReason}
        onBlur={(event) => { onInputChange(event.target.value) }}
        onSelectChange={(event) => { onInputChange(event.target.value) }}
        onInputChange={(event) => { onInputChange(event.target.value) }}
        options={OPTIONS}
        autoFocus
      />

      <S.ButtonContainer>
        <Button decoration="secondary" styles={{ button: { marginRight: 15 } }} text="Cancel" onPress={onCancelButtonClicked} />
        <Button decoration="positive" text={displayActionType} onPress={async () => await onCreateOrUpdateButtonClicked()} />
      </S.ButtonContainer>
    </Modal>
  )
}

const S = {
  ButtonContainer: styled(ButtonContainer)`
    margin-top: 0px;
  `,
  DeviceId: styled.div`
    margin-bottom: 20px;
  `
}

export default ArchiveDeviceModal
